<template>
  <div class="gallery" :style="`background-color:${theme.searchBgColor}`">
    <div v-if="sort" class="gallery-filter" @click="gallerySort">
      <i class="gallery-sort"></i>
      <span>排序</span>
    </div>
    <div class="gallery-view" v-for="item in gallery" :key="item.title" @click="select(item)">
      <icon-svg class="icon-small" :iconClass="getIcon(item)"></icon-svg>
      <span>
        {{item.title}}
      </span>
    </div>
  </div>
</template>

<script>
import '@/assets/less/galleryView.less'
export default {
  data(){
    return {
      sortState: false,
      gallery: [
        {
          title: '一列',
          icon: 'one-column',
          value: 1,
          suffix: '?x-oss-process=style/thumail_onelist'
        },
        {
          title: '二列',
          icon: 'two-column',
          value: 2,
          suffix: '?x-oss-process=style/thumail_twolist'
        },
        {
          title: '三列',
          icon: 'three-column',
          value: 3,
          suffix: '?x-oss-process=style/thumail_threelist'
        },
        {
          title: '四列',
          icon: 'four-column',
          value: 4,
          suffix: '?x-oss-process=style/thumail_fourlist'
        }
      ]
    }
  },
  props:{
    column: Number,
    sort: Boolean,
    theme: {
      type: Object,
      default: function(){
        return {
          footerColor: "#fff",
          bgColor: "#fff",
          searchBgColor: "#fff"
        }
      }
    }
  },
  methods: {
    select(item){
      this.$emit('change', item)
    },
    gallerySort(){
      this.$data.sortState = !this.$data.sortState;
      this.$emit('gallerySort', this.$data.sortState)
    },
    getIcon(item){
      if(this.column == item.value){
        return item.icon + '-active'
      } else {
        return item.icon
      }
    }
  }
}
</script>

<style>

</style>